import { __decorate } from "tslib";
import { makeObservable, observable } from 'mobx';
import { UIStore } from './UI/UIStore';
import { UserStore } from './User/UserStore';
import { NavigationStore } from './Navigation/NavigationStore';
import { ComplaintStore } from './Complaint/ComplaintStore';
import { ComplaintSupportStore } from './Complaint/ComplaintSupportStore';
var UCFStore = /** @class */ (function () {
    function UCFStore() {
        Object.defineProperty(this, "UI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "navigation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "complaint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "complaintSupport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this);
        this.UI = new UIStore(this);
        this.navigation = new NavigationStore(this);
        this.user = new UserStore(this);
        this.complaint = new ComplaintStore(this);
        this.complaintSupport = new ComplaintSupportStore(this);
    }
    __decorate([
        observable
    ], UCFStore.prototype, "UI", void 0);
    __decorate([
        observable
    ], UCFStore.prototype, "navigation", void 0);
    __decorate([
        observable
    ], UCFStore.prototype, "user", void 0);
    __decorate([
        observable
    ], UCFStore.prototype, "complaint", void 0);
    __decorate([
        observable
    ], UCFStore.prototype, "complaintSupport", void 0);
    return UCFStore;
}());
export { UCFStore };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVUNGU3RvcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvU3RvcmUvVUNGU3RvcmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBQyxjQUFjLEVBQUUsVUFBVSxFQUFDLE1BQU0sTUFBTSxDQUFDO0FBQ2hELE9BQU8sRUFBQyxPQUFPLEVBQUMsTUFBTSxjQUFjLENBQUM7QUFDckMsT0FBTyxFQUFDLFNBQVMsRUFBQyxNQUFNLGtCQUFrQixDQUFDO0FBQzNDLE9BQU8sRUFBQyxlQUFlLEVBQUMsTUFBTSw4QkFBOEIsQ0FBQztBQUM3RCxPQUFPLEVBQUMsY0FBYyxFQUFDLE1BQU0sNEJBQTRCLENBQUM7QUFDMUQsT0FBTyxFQUFDLHFCQUFxQixFQUFDLE1BQU0sbUNBQW1DLENBQUM7QUFFeEU7SUFPRTtRQU5ZOzs7OztXQUFZO1FBQ1o7Ozs7O1dBQTRCO1FBQzVCOzs7OztXQUFnQjtRQUNoQjs7Ozs7V0FBMEI7UUFDMUI7Ozs7O1dBQXdDO1FBR2xELGNBQWMsQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUNyQixJQUFJLENBQUMsRUFBRSxHQUFHLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQzVCLElBQUksQ0FBQyxVQUFVLEdBQUcsSUFBSSxlQUFlLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDNUMsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLFNBQVMsQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUNoQyxJQUFJLENBQUMsU0FBUyxHQUFHLElBQUksY0FBYyxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQzFDLElBQUksQ0FBQyxnQkFBZ0IsR0FBRyxJQUFJLHFCQUFxQixDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzFELENBQUM7SUFiVztRQUFYLFVBQVU7d0NBQWE7SUFDWjtRQUFYLFVBQVU7Z0RBQTZCO0lBQzVCO1FBQVgsVUFBVTswQ0FBaUI7SUFDaEI7UUFBWCxVQUFVOytDQUEyQjtJQUMxQjtRQUFYLFVBQVU7c0RBQXlDO0lBVXRELGVBQUM7Q0FBQSxBQWZELElBZUM7U0FmWSxRQUFRIn0=